import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
import { hasScope } from 'ContentUtils/helpers/scopes';
/**
 * GET designmanager/v1/theme/by-path/{path}/with-settings
 */
export function fetchThemeSettings(path, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`designmanager/v1/themes/by-path/${encodeURIComponent(path)}/with-settings`, {
    query: {
      includeBufferedPresetStyles: hasScope('default-theme-presets') || hasScope('branded-theme-presets')
    }
  });
}